import * as React from 'react';

import InfiniteScrollIndicator from 'components/infinite-load-indicator/InfiniteScrollIndicator';

import InspirationalMaterialsGridItem from './item/InspirationalMaterialsGridItem';

import type { ImageStandard } from 'types';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

import './inspirational-materials-grid.scss';

type Props = {
  assets: Array<ImageStandard>,
  hasMorePages: boolean,
  withCloudinary?: boolean,
  isLoading: boolean,
  userChannelConsents: ConsentReducerConsentsMap,
  onLoadMore: () => void,
  onSelect: (a: ImageStandard) => void
};

const InspirationalMaterialsGrid = (
  {
    assets,
    isLoading,
    hasMorePages,
    onLoadMore,
    onSelect,
    withCloudinary,
    userChannelConsents
  }: Props
): JSX.Element => (
  <React.Fragment>
    <section className="inspirational-materials-grid">
      {
        assets.map((asset, index) => (
          <InspirationalMaterialsGridItem
            key={`${asset.code}-${index}`}
            userChannelConsents={userChannelConsents}
            withCloudinary={withCloudinary}
            asset={asset}
            onSelect={onSelect}
          />
        ))
      }
    </section>
    {hasMorePages && (
      <InfiniteScrollIndicator
        isLoading={isLoading}
        onLoadMore={onLoadMore}
        detectionOffset={200}
      />
    )}
  </React.Fragment>
);

export default InspirationalMaterialsGrid;
